module.exports = __webpack_public_path__ + "static/media/smallvile.385ebe2d.mp3";